import React from "react";
import LLogo from "../dist/img/LOGO.png";
import Whatsapp from "../SVG/Whatsapp";
import Twitter from "../SVG/Twitter";
import Insta from "../SVG/Insta";
import Mail from "../SVG/Mail";
import LinkedIn from "../SVG/LinkedIn";

export default function Footer() {
  return (
    <div
      className="footer mt-1"
      style={{
        minHeight:"00px",
        maxWidth: "1280px",
        marginLeft: "auto",
        padding: "0px",
        marginRight: "auto",
        backgroundColor: "#202020",
      }}
    >
      <main>
        <div className="row">
          <div className="col-md-3 d-flex justify-content-center align-items-center">
            <img alt=""
              style={{ height: "200px", width: "200px", margin: "10px" }}
              src={LLogo}
              loading="lazy"
            ></img>
          </div>
          <div
            className="col-md-5 d-flex mt-4 justify-content-center align-items-center"
            style={{ color: "white", flexDirection: "column", marginLeft:"10px" }}
          >
            <h3 style={{ color: "pink" }}>Reach Out Anytime!</h3>
            <p className="footerParaghraph" style={{ color: "white" }}>
            I would love to hear from you! If you have any questions, inquiries, or potential collaboration opportunities, please feel free to reach out. I have a strong problem-solving mindset, which allows me to tackle challenges effectively. This quality enables me to work for any role in a company, and I'm always open to discussing new projects and partnerships. Your thoughts and ideas are important to me, and I look forward to connecting and exploring how we can work together! Let’s create something amazing together!


            </p>
          </div>
          <div
            className="col-md-3 d-flex mt-3"
            style={{ color: "white", flexDirection: "column" }}
          >
            <h4 className="m-3" style={{ color: "pink" }}>Contact Me If You Are</h4>
            <p className="m-2">
              {" "}
              <ul>
                <li>An Employee</li>
                <li>A Freelencer</li>
                <li>A Student</li>
                <li>A Startup Founder</li>
                <li>An Enthusiast in Technology
                </li>
              </ul>
            </p>
            <div className="d-flex" style={{marginLeft:"25px"}}>
                <a href="https://wa.me/918923163204" rel="noreferrer"  target="_blank" className="svg" style={{cursor:"pointer"}}>  <Whatsapp/> </a>
                <a href="https://x.com/Lakshya7370" rel="noreferrer"  target="_blank" className="svg" style={{cursor:"pointer"}}>   <Twitter /></a>
                <a href="https://www.instagram.com/drrtech2/" target="_blank"  rel="noreferrer" className="svg" style={{cursor:"pointer"}}> <Insta /></a>
                <a href="https://lakshyak7370@gmail.com" target="_blank"  rel="noreferrer" className="svg" style={{cursor:"pointer"}}> <Mail/></a>
                <a href="www.linkedin.com/in/lakshyak7370/" target="_blank"  rel="noreferrer" className="svg" style={{cursor:"pointer"}}> <LinkedIn /></a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
